/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Level export format
 */
export interface ExportedLevel {
  enumerator: string;
  title: string;
  objectives?: string[];
}
